import { Text } from "@chakra-ui/react";
import HeroSection from "../HeroSection";

export default function AboutPage() {
  return (
    <>
      <HeroSection />
      <Text>
        <br></br>
        <p>
          MeMA is the best way to discover, enjoy and support all the creators
          that make up the best part of the internet! This is where you’ll find
          the deep-fried, most dank and inspiring memes, culture, cat-GIFs, and
          other fantastical golden nuggets. Powered by the crazy idea of
          supporting the creators, they get paid for the traffic they generate
          instead of it getting zucked away for profits!
        </p>
        <br></br>
        <p>
          Driven by the best looking and, frankly, humblest of communities with
          people from all around the Baltic Sea that just wants to create a
          better and fairer place for all the creators and connoisseurs out
          there!
        </p>
      </Text>
    </>
  );
}
